import React from 'react';
import {
  AnyMemo,
  AudioMemo,
  DocMemo,
  FileMemo,
  ImageMemo,
  MemoType,
  VideoMemo,
} from 'models/Memo';
import TextForm from './forms/TextForm';
import QuoteForm from './forms/QuoteForm';
import LinkForm from './forms/LinkForm';
import TaskListForm from './forms/TaskListForm';
import DocForm from './forms/DocForm';
import ImageForm from './forms/ImageForm';
import AudioForm from './forms/AudioForm';
import VideoForm from './forms/VideoForm';
import FileForm from './forms/FileForm';
import { useMemoFormContext } from './context/FormContext';
import CalendarForm from './forms/CalendarForm';
import { useTranslations } from 'next-intl';

interface Props {
  memo?: AnyMemo | null;
}

export const MemoContentForm: React.FC<Props> = ({ memo }) => {
  const t = useTranslations();
  const { selectedMemoType } = useMemoFormContext();

  // Render the appropriate form based on the memo type
  switch (selectedMemoType) {
    case MemoType.Text:
      return <TextForm />;

    case MemoType.Quote:
      return <QuoteForm />;

    case MemoType.Link:
      return <LinkForm />;

    case MemoType.TaskList:
      return <TaskListForm />;

    case MemoType.Doc:
      return <DocForm memo={memo as DocMemo} />;

    case MemoType.Calendar:
      return <CalendarForm />;

    case MemoType.Image:
      return <ImageForm memo={memo as ImageMemo} />;

    case MemoType.Audio:
      return <AudioForm memo={memo as AudioMemo} />;

    case MemoType.Video:
      return <VideoForm memo={memo as VideoMemo} />;

    case MemoType.File:
      return <FileForm memo={memo as FileMemo} />;

    default:
      return <div>{t('memoComposer.unsupportedType')}</div>;
  }
};
